var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.step == "form"
      ? _c("div", [
          _c("label", { staticClass: "form__label footer__form-label" }, [
            _vm._v("Закажите звонок консультанта:"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer__form-call" }, [
            _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "+7(###)###-##-##",
                  expression: "'+7(###)###-##-##'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contact.contact,
                  expression: "contact.contact",
                },
              ],
              staticClass: "form-control footer__form-control",
              class: { "is-invalid": _vm.errors.contact },
              attrs: { placeholder: "+7(xxx)xxx-xx-xx", type: "tel" },
              domProps: { value: _vm.contact.contact },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.contact, "contact", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--promo-orange footer__form-btn",
                attrs: { type: "button" },
                on: { click: _vm.sendForm },
              },
              [_vm._v("Заказать звонок")]
            ),
          ]),
          _vm._v(" "),
          _vm.errors.contact
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.errors.contact.join(", ")) + "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(0),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step == "complete"
      ? _c("div", [
          _c("p", { staticClass: "text-success" }, [
            _vm._v(
              "\n      Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.\n    "
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form__note" }, [
      _vm._v("Отправляя заявку, Вы соглашаетесь \n        с нашей "),
      _c("a", { attrs: { href: "/legal/" } }, [
        _vm._v("политикой конфиденциальности"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }